<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,6.5C12,6.22,11.780000000000001,6,11.5,6C11.5,6,4.5,6,4.5,6C4.22,6,4,6.22,4,6.5C4,6.63,4.05,6.74,4.13,6.83C4.13,6.83,4.13,6.83,4.13,6.83C4.13,6.83,7.63,10.83,7.63,10.83C7.63,10.83,7.63,10.83,7.63,10.83C7.720000000000001,10.93,7.85,11,8,11C8.15,11,8.280000000000001,10.93,8.370000000000001,10.83C8.370000000000001,10.83,8.370000000000001,10.83,8.370000000000001,10.83C8.370000000000001,10.83,11.870000000000001,6.83,11.870000000000001,6.83C11.870000000000001,6.83,11.870000000000001,6.83,11.870000000000001,6.83C11.95,6.74,12,6.63,12,6.5C12,6.5,12,6.5,12,6.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CaretDown',
} as DefineComponent
</script>
